// services/member.ts
import api from './api';
import { Member } from '../types/member';

export const memberService = {
    async getAllMembers(): Promise<Member[]> {
        try {
            const response = await api.get('/members/list');
            return response.data.members;
        } catch (error) {
            console.error('メンバー一覧の取得に失敗:', error);
            throw error;
        }
    },

    async getMemberById(ID: number): Promise<Member> {
        try {
            const response = await api.get(`/members/${ID}`);
            return response.data;
        } catch (error) {
            console.error('メンバー詳細の取得に失敗:', error);
            throw error;
        }
    }
};